<template>
  <svg
    height="40"
    width="40"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="sxs-builder-logo"
        x1="0"
        y1="0"
        x2="1"
        y2="1"
      >
        <stop
          offset="0"
          stop-color="#2A06B0"
        />
        <stop
          offset="1"
          stop-color="#7133E5"
        />
      </linearGradient>
    </defs>
    <rect
      x="20"
      y="28"
      width="60"
      height="13"
      rx="6.5"
      fill="#A89FFF"
      opacity="0.42"
    />
    <rect
      x="20"
      y="49"
      width="46"
      height="13"
      rx="6.5"
      fill="#A89FFF"
      opacity="0.28"
    />
    <path
      d="M24 70 L 45 90 C 63 73, 80 51, 100 27"
      fill="none"
      stroke="url(#sxs-builder-logo)"
      stroke-width="16"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="100"
      cy="27"
      r="9"
      fill="#16C79A"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
